export default __webpack_public_path__ + "3f51a37f7d936cf600e85008de05989a.svg";